import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { GetAgoTime } from '../components/getAgoTime';
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Loadingimg from "../components/loadingimg";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
import Header from '../master_root/header';
import { NumberFormatter } from '../components/numberFormatter';
import Footer from '../master_root/footer';
//page links  
import Navbar from '../master_root/Navbar';
import { Randomcode } from '../components/rendom_code';
import './feed.css';
import './feed_ui.css';
import { MdAdd, MdUpload } from 'react-icons/md';
export default function Feed() {
  const location = useLocation(); // Get current route
  const navigate = useNavigate();
  const [feedsData, setFeedsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetchsetFeedsData();
  });
  const fetchsetFeedsData = async () => {
    try {
      const feedsQuery = query(
        collection(db, "feeddata"),
        where("public", "==", true),
        where("status", "==", true)
      );
      const feedsSnapshot = await getDocs(feedsQuery);
 
         
        
      const dataList = await Promise.all(
        feedsSnapshot.docs.map(async (doc) => {
          const feedData = { id: doc.id, ...doc.data() };

          const detailsQuery = query(
            collection(db, "users"),
            where("guid", "==", feedData.guid)
          );

          const detailsSnapshot = await getDocs(detailsQuery);
          const userData =
            detailsSnapshot.docs.map((detailsDoc) => ({
              uid: detailsDoc.id,
              ...detailsDoc.data(),
            }))[0] || null;

          return {
            ...feedData, // fixed from feedData to usersData
            userData: userData,
          };
        })
      );

      setFeedsData(dataList);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div >
      <Header />
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>Showcase Your Creative Skills & Projects | EditorTask</title>
          <meta name="description" content="Display your portfolio, projects, and professional skills on EditorTask. From videos and graphics to writing samples and animation—impress potential clients now!" />
          <meta name="keywords" content="showcase portfolio, editor skills, creative portfolio, design showcase, video editing samples, writing projects, animation work, EditorTask talents" />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="Showcase Your Creative Skills & Projects | EditorTask" />
          <meta property="og:description" content="Build your public profile by uploading your work. Share short projects, images, skills, and creative talents to get noticed by job providers and clients." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/skills-showcase" />
          <meta property="og:image" content="https://www.editortask.com/images/showcase_preview.png" />
        </Helmet>


        <div className="container_size">
          <br />
          <div className='post-container'>
            {/* <div className="contact-title">Showcase Your Creative Skills & Projects | EditorTask</div>    */}
          </div>

          <div className='post-container'>
            <div className='post_div'>
              <div className='post-list-body'>
                <div className='recommend-div'>
                  <div className='recommend-text active'>All</div>
                  <div className='recommend-text'>Tech</div>
                </div>
                <div className='button-ui0 button-upload' onClick={() => navigate('/feed-details?uid=' + Randomcode(13))}><MdUpload className='icon' />Upload</div>
              </div>
              {/* feedsUI-grid */}
              <div className='feedsUI-grid'>
                {isLoading ? (
                  <Loadingimg />
                ) : feedsData.length === 0 ? (
                  <p>No feeds available.</p>
                ) : (
                  feedsData.map((feeds) => (
                    <div className="feeds-items" onClick={() => navigate('/'+feeds.slug)} key={feeds.id}>
                      <div className="photo-ui-body">
                        <img className="photo-ui-img" src={feeds.file_url} alt="Feed" />
                      </div>
                      <div className='info-div'>
                        <div className='title-text'>{feeds.title.substring(0, 50)}</div>
                        <div className='info-body'>
                          <div className='feed-ui-photo-div'>
                            {feeds.file_url ? (
                              <img src={feeds.userData.photoURL} className='photo-img' />
                            ) : (
                              <Loadingimg />
                              
                            )}
                          </div>
                          <div className='feed-name-div'>
                            <table>
                              <tr><div className='name-text'>{feeds.userData.name.substring(0, 30)}</div></tr>
                              <tr><div className='subscriber-text'>{feeds.userData.subscriber} Subscriber</div>
                              </tr>
                            </table>
                          </div>
                          <div className='view-div'>
                            <div className='view-text'>{NumberFormatter(feeds.views)} Views</div>
                                   <div className='view-text'>{NumberFormatter(feeds.like)} Like</div>
                            <div className='date-text'>{GetAgoTime(feeds.date_time)}</div>

                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className='post_updates'>
              <div className='recommend-div'>
                <div className='recommend-text active'>All</div>
                <div className='recommend-text'>Tech</div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <Navbar/>
      <Footer/>
    </div>
  );
}
